import { BreadcrumbNavigatorSVG } from "@/assets/svg";
import React from "react";
import { useLocation } from "react-router";

interface BreadcrumbProps {
  className?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ className = "" }) => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x: string) => x);

  // Map of route paths to display names
  const routeNameMap: Record<string, string> = {
    projects: "Projects",
    clients: "Clients",
    "users-management": "Users",
    "time-entry": "Time Entry",
    reports: "Reports",
    "time-entries": "Time entries",
    "project-tracking": "Project tracking report",
    "month-breakdown": "Month wise breakdown",
  };

  return (
    <div
      className={`flex items-center flex-wrap w-full max-w-full overflow-x-auto ${className} text-[#6C6C6C] text-[11px] sm:text-[12px] font-[500]`}
    >
      {pathnames.length > 0 ? (
        <div className="flex flex-wrap items-center space-x-1 sm:space-x-3 w-full max-w-full overflow-x-auto">
          {pathnames.map((name: string, index: number) => {
            // Build the path up to this point
            const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
            const isLast = index === pathnames.length - 1;
            const displayName =
              routeNameMap[name] ||
              name.charAt(0).toUpperCase() + name.slice(1);

            return (
              <React.Fragment key={name}>
                {index > 0 && !isLast && <BreadcrumbNavigatorSVG />}
                {!isLast && (
                  <span className="">{displayName}</span>
                  // ) : (
                  //   <Link
                  //     to={routeTo}
                  //     className="hover:text-primary-600 transition-colors"
                  //   >
                  //     {displayName}
                  //   </Link>
                )}
              </React.Fragment>
            );
          })}
        </div>
      ) : (
        <span className="">Home</span>
      )}
    </div>
  );
};

export default Breadcrumb;
